import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import unexpectedEventsAndLongTimeContinuousDrivingExtensions from "src/types/responses/unexpectedEventsAndLongTimeContinuousDrivingExtensions";
import UnexpectedEventRegisterModal from "@/components/DailyReportUpdateModalParts/UnexpectedEventRegisterModal.vue";
import UnexpectedEventConfirmModal from "@/components/DailyReportUpdateModalParts/UnexpectedEventConfirmModal.vue";
import getUnexpectedEventType from "@/types/responses/getUnexpectedEvent";
import Api from "@/services/api/ApiServiceFabrick";
import DeliveryPlan from "@/types/DeliveryPlan";
import { Ref, ref, computed } from "vue";
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'UnexpectedEventModals',
  props: {
    modelValue: { type: Boolean },
    deliveryPlan: { default: {} },
    unexpectedEvent: {},
    selectedUnexpectedEvent: {},
    getUnexpectedEventAndLongTimeDrivingExtensions: {},
    createAuthority: { type: Boolean, default: true },
    updateAuthority: { type: Boolean, default: true },
    showFlash: {}
  },
  emits: ['update:modelValue', 'cancel'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit

const props = __props

const localUnexpectedEvent = ref({} as getUnexpectedEventType)
const isUnexpectedEventLoading: Ref<boolean> = ref(false)
const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits('update:modelValue', value);
  },
})

const registerModalStatus: Ref<boolean> = ref(false)

const registerModalTitle = computed(() => {
  return `${i18n.global.t('pages.dailyReports.unexpectedEventRegisterModal.titlePrefix')}${registerModalTitleSuffix.value}`
})

const registerModalTitleSuffix = computed(() => {
  return props.selectedUnexpectedEvent ? i18n.global.t('pages.dailyReports.unexpectedEventRegisterModal.editTitle') : i18n.global.t('pages.dailyReports.unexpectedEventRegisterModal.registerTitle')
})

function confirm() {
  modelValue.value = false
  registerModalStatus.value = true
  if (props.selectedUnexpectedEvent) getUnexpectedEvent(props.selectedUnexpectedEvent)
}

function getUnexpectedEvent(item: unexpectedEventsAndLongTimeContinuousDrivingExtensions) {
  isUnexpectedEventLoading.value = true
  Api().getUnexpectedEvent(item.id).then((data: getUnexpectedEventType) => {
    localUnexpectedEvent.value = data
    isUnexpectedEventLoading.value = false
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(UnexpectedEventConfirmModal, {
      modelValue: modelValue.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
      confirm: confirm
    }, null, 8, ["modelValue"]),
    (registerModalStatus.value)
      ? (_openBlock(), _createBlock(UnexpectedEventRegisterModal, {
          key: 0,
          modelValue: registerModalStatus.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((registerModalStatus).value = $event)),
          title: registerModalTitle.value,
          deliveryPlan: props.deliveryPlan,
          unexpectedEvent: localUnexpectedEvent.value,
          isUnexpectedEventLoading: isUnexpectedEventLoading.value,
          getUnexpectedEventAndLongTimeDrivingExtensions: props.getUnexpectedEventAndLongTimeDrivingExtensions,
          createAuthority: props.createAuthority,
          updateAuthority: props.updateAuthority,
          showFlash: props.showFlash
        }, null, 8, ["modelValue", "title", "deliveryPlan", "unexpectedEvent", "isUnexpectedEventLoading", "getUnexpectedEventAndLongTimeDrivingExtensions", "createAuthority", "updateAuthority", "showFlash"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})